import { useEffect, useContext } from 'react';
import { AppContext } from '../services/AuthContext';
import { sendPageLog } from '../services/systemSettingsService';

/**
 * Custom hook to track page visits.
 * @param {string} pagename - The name of the page to log (without leading slash).
 */
const usePageTracking = (pagename) => {
  const { auth } = useContext(AppContext);
  const token = auth?.token;

  useEffect(() => {
    if (pagename) {
      sendPageLog(pagename, token);
    }
  }, [pagename, token]);
};

export default usePageTracking;
